import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaLocationCrosshairs } from "react-icons/fa6";

const AddressSection = ({
  selected,
  setSelected,
  savedAddresses,
  newAddress,
  setNewAddress,
  locationData,
}) => {
  const navigate = useNavigate();

  const handleChangeAddress = () => {
    // console.log("change address clicked");
    setSelected("no");
    navigate("/AddressSection", { state: { savedAddresses } });
  };

  const currentLocation = JSON.parse(localStorage.getItem("userLocation"));
  const handlecurrent = () => {
    // console.log('clicked')
    setNewAddress(currentLocation?.address || "");
  }

  return (
    <div className="addressrow">
      <div className="address-header">
        <p className="fontAD">Delivery To this Address</p>

        {/* <button
          type="button"
          className={`select-btn ${selected === "no" ? "active" : ""}`}
          onClick={handleChangeAddress}
        >
          Change Address
        </button> */}

        <button
          type="button"
          className={`select-btns ${selected === "no" ? "active" : ""}`}
          onClick={() => {
            // navigate('/Cart', { state: { choosen: "yes" } });
            handlecurrent()
          }}
          title="Use Current Location"
        >
          <FaLocationCrosshairs size={20} />
        </button>
      </div>

      <textarea
        placeholder="Delivery address"
        value={newAddress}
        onChange={(e) => setNewAddress(e.target.value)}
        rows={3}
        className="address-textarea"
      />
    </div>
  );
};

export default AddressSection;
